module.exports = __webpack_public_path__ + "img/logo.b2e15a03.png";